import React from 'react';
import '../../../../styles/full-view-popup.scss';

interface IEditActivityPopupProps {
  onClose: () => void;
  header: string;
}

export const ActivityPopup: React.FunctionComponent<IEditActivityPopupProps> = (
  props
) => {
  return (
    <div className="modal-open">
      <div className="detail-poupup bg-white position-fixed top-0 h-100 overflow-auto in col-4 px-0" style={{zIndex : 99999}}>
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-99">
          <div className="row align-items-center">
            <div
              className="col-auto"
              onClick={() => {
                props.onClose();
              }}
            >
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">{props.header}</h5>
            </div>
          </div>
        </div>
        {props.children}
      </div>

      <div className="modal-backdrop fade show" style={{zIndex : 9999}}></div>
    </div>
  );
};
